const modifySubmissionAuthor = function (
  { commit, dispatch },
  { id, field, value }
) {
  commit("UPDATE_SUBMISSION_AUTHOR", { id, field, value });
  dispatch("validateSubmission");
};

export default modifySubmissionAuthor;
